import { useAuth } from '@/app/auth';
import Button from '@/components/Button/Button';

export default function UnauthorizedScreen() {
  const { user, signOut } = useAuth();

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-(--bg-app-solid) px-4">
      <div className="flex w-full max-w-sm flex-col items-center text-center">
        <h1 className="font-display mb-3 text-3xl font-bold tracking-wider text-(--text-primary)">Access denied</h1>
        <p className="mb-2 text-sm text-(--text-secondary)">
          {user?.email ? (
            <>
              The account <span className="text-(--text-primary)">{user.email}</span> isn’t allowed to view this dashboard.
            </>
          ) : (
            'This account isn’t allowed to view this dashboard.'
          )}
        </p>
        <p className="mb-8 text-xs text-(--text-tertiary)">Sign out and try a different Google account.</p>
        <Button
          variant="secondary"
          size="lg"
          onClick={() => {
            void signOut();
          }}
          className="w-full"
        >
          Sign out
        </Button>
      </div>
    </div>
  );
}
